// Copyright 2023, Durable

/* eslint-disable no-console */

// These functions primarily wrap console.log, so as to allow us to easily
// shut off all logging for production. They are built to roughly match the
// API of the logger we currently use in python for the sake of standardization

export enum logggingLevel {
  DEBUG,
  INFO,
  WARNING,
  ERROR,
  OFF
}

/**
 * Get the current logging level. If there's nothing there, display no logs.
 */
function currentLoggingLevel() {
  if (process.env.NODE_ENV == "development") {
    return logggingLevel.INFO;
  } else {
    return logggingLevel.OFF;
  }
}

// A basic logging function to allow us to control logging without assigning
// function stubs to console. Also serves to make internal logging output more
// obviously distinct.
export const logging = {
  debug: function (message: unknown, ...optionalParams: any[]) {
    if (currentLoggingLevel() <= logggingLevel.DEBUG) {
      if (typeof message == "string") {
        console.log("📓 " + message, ...optionalParams);
      } else {
        console.log(message, ...optionalParams);
      }
    }
  },
  info: function (message: unknown, ...optionalParams: any[]) {
    if (currentLoggingLevel() <= logggingLevel.INFO) {
      if (typeof message == "string") {
        console.info("%c📘 " + message, "color: #9efae1", ...optionalParams);
      } else {
        console.info(message, ...optionalParams);
      }
    }
  },
  warning: function (message: unknown, ...optionalParams: any[]) {
    if (currentLoggingLevel() <= logggingLevel.WARNING) {
      if (typeof message == "string") {
        console.warn("📙 " + message, ...optionalParams);
      } else {
        console.warn(message, ...optionalParams);
      }
    }
  },
  error: function (message: unknown, ...optionalParams: any[]) {
    if (currentLoggingLevel() <= logggingLevel.ERROR) {
      if (typeof message == "string") {
        console.error("📕 " + message, ...optionalParams);
      } else {
        console.error(message, ...optionalParams);
      }
    }
  }
};

/* eslint-enable no-console */
